var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherIconSilhouette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.604 30c-30.169 12.983-57.921 61.884-65.085 83.814-1.59 4.872-2.993 10.205 1.603 1.7 2.754-5.098 9.57-12.274 25.115-14.848 12.435-2.06 17.642-4.736 25.616-13.839-3.676 1.324-8.425 4.092-18.562.92 14.057 1.24 23.743-7.128 27.528-19.034-9.281 4.23-17.136 1.27-19.193.182 12.66.32 23.338-7.768 25.906-21.239 1.497-7.852-.901-15.081-2.928-17.656Z",
    fill: "#5754BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherIconSilhouette);
export default __webpack_public_path__ + "static/media/feather-icon-silhouette.651223e3ae92cb1a2600e410f4c71daa.svg";
export { ForwardRef as ReactComponent };